// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"357":"fb444d8e","511":"fb444d8e","896":"fb444d8e","926":"fb444d8e","954":"fb444d8e"}[chunkId] + ".css";
};